import { GET_USER_MY_TEAM, GET_USER_MY_TEAM_SUCCESSFUL, GET_USER_MY_TEAM_FAILED, UPDATE_USER_MY_TEAM, UPDATE_USER_MY_TEAM_SUCCESSFUL, UPDATE_USER_MY_TEAM_FAILED } from "./actionTypes";

const initialState = {
    loader: false,
    buttonLoader: false,
    userMyTeam: null,
    successMessage: null,
    errorMessage: null    
}
const getUpdateUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_MY_TEAM:
            state = {
                ...state,
                loader: true,
                successMessage: null,
                errorMessage: null,
            }
            break
        case GET_USER_MY_TEAM_SUCCESSFUL:
            state = {
                ...state,
                loader: false,
                userMyTeam: action.payload,
                successMessage: null,
                errorMessage: null,               
            }
            break
        case GET_USER_MY_TEAM_FAILED:
            state = {
                ...state,
                loader: false,
                userMyTeam: null,
                successMessage: null,
                errorMessage: action.payload,                
            }
            break
        case UPDATE_USER_MY_TEAM:
            state = {
                ...state,
                loader: false,
                userMyTeam:null,
                buttonLoader: true,
                successMessage: null,
                errorMessage: null,
            }
            break
        case UPDATE_USER_MY_TEAM_SUCCESSFUL:
            state = {
                ...state,
                loader: false,
                userMyTeam:null,
                buttonLoader: false,
                successMessage: action.payload,
                errorMessage: null,                
            }
            break
        case UPDATE_USER_MY_TEAM_FAILED:
            state = {
                ...state,
                loader: false,
                buttonLoader: false,
                successMessage: null,
                errorMessage: action.payload,  
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}
export default getUpdateUserReducer